import React, { useState } from 'react';
import { Alert, Center, Grid, Stack } from '@mantine/core';
import { getRings, getSections, updateRings, updateSections } from '../../Util/server';
import { useLoaderData } from 'react-router';
import { RingsAndSectionsResult } from '../../Loaders/RingsAndSectionsLoader';
import EntityManagement from '../../Components/EntityManagement';
import { IconAlertCircle } from '@tabler/icons';
import { NavLink } from 'react-router-dom';

const RadarAdmin = () => {
  const { rings, sections } = useLoaderData() as RingsAndSectionsResult;
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Stack>
      <Center>
        <Alert icon={<IconAlertCircle size={16} />} title="Beware!" color="red" w={600} maw={'100%'}>
          The radar will only render the sections and rings present in these lists. Technologies in other rings/sections
          will not be deleted but needs to have a proper value set for both properties in order to be displayed again.
          Technologies with invalid values will still be listed (and highlighted) for admins in the{' '}
          <NavLink to={`/technologies`}>technology list</NavLink> to make it easier for you to identify and fix them.
        </Alert>
      </Center>
      <Center>
        <Grid align={'flex-start'} justify={'center'} gutter={'xl'} maw={'100%'}>
          <Grid.Col span={12} lg={6}>
            <EntityManagement
              initial={sections}
              getEntities={getSections}
              updateEntities={updateSections}
              heading={'Sections'}
              textAboveList={`Sections start at 9 o'clock and grow clockwise`}
              label={'Add new section'}
              placeholder={'Section name'}
              maxEntities={12}
              editUrlPath={'section'}
              loading={loading}
              setLoading={setLoading}
            />
          </Grid.Col>
          <Grid.Col span={12} lg={6}>
            <EntityManagement
              initial={rings}
              getEntities={getRings}
              updateEntities={updateRings}
              heading={'Rings'}
              textAboveList={'Inner-most'}
              textBelowList={'Outer-most'}
              label={'Add new ring'}
              placeholder={'Ring name'}
              maxEntities={5}
              editUrlPath={'ring'}
              loading={loading}
              setLoading={setLoading}
              isRings
            />
          </Grid.Col>
        </Grid>
      </Center>
    </Stack>
  );
};

export default RadarAdmin;
